var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.716,
    height: 48.089,
    viewBox: "0 0 55.716 48.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    "data-name": 3,
    transform: "translate(-10818.724 -6460.29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6586",
    "data-name": "Path 6586",
    d: "M10843.537,6460.418a28.012,28.012,0,0,0-16.242,7.648,27.916,27.916,0,0,0-8.57,20.122,27.754,27.754,0,0,0,6.279,17.532c1.307,1.6,2.289,2.512,2.836,2.611a1.955,1.955,0,0,0,2.314-1.406c.235-.845.023-1.331-1.1-2.55a22.813,22.813,0,0,1-4.128-6.118,23.848,23.848,0,0,1,3.108-25.232,32.7,32.7,0,0,1,4.24-4.066,23.923,23.923,0,0,1,29.4.622,32.634,32.634,0,0,1,4.066,4.241,23.889,23.889,0,0,1,2.475,24.474,23.478,23.478,0,0,1-4.116,6.081c-1.119,1.219-1.331,1.7-1.094,2.55a1.954,1.954,0,0,0,2.313,1.406c1.244-.223,4.465-4.328,6.255-7.958a27.912,27.912,0,0,0-22.2-39.979A36.689,36.689,0,0,0,10843.537,6460.418Z",
    transform: "translate(0 0)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6587",
    "data-name": "Path 6587",
    d: "M10854.211,6493.92a2.674,2.674,0,0,0-.783,4.5c.445.422,7.81,6.342,8.307,6.677a1.653,1.653,0,0,0,.846.212,1.188,1.188,0,0,0,1.269-1.1,1.551,1.551,0,0,0,0-.165,1.685,1.685,0,0,0-.212-.846c-.113-.174-1.643-2.1-3.4-4.29s-3.258-4.141-3.333-4.327C10856.624,6493.895,10855.106,6493.521,10854.211,6493.92Z",
    transform: "translate(-8.688 -8.605)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel);
export default __webpack_public_path__ + "static/media/level.8aaee1b338882498083363c8b4a53b9a.svg";
export { ForwardRef as ReactComponent };